import WebAppLayout from '@/components/organisms/WebAppLayout';
import { router } from 'expo-router';
import React from 'react';
import { useWindowDimensions } from 'react-native';
import { PropertiesDetailsScreenSkeleton } from '../components/skeleton';
import { usePropertyLabels } from '../hooks/usePropertyLabels';
import { getUnitDetailsLayout } from './unitDetailsLayout';

/**
 * Lightweight unit-details chrome + shimmer.
 * Used for Suspense fallback and first paint before heavy details mount.
 */
export function PropertiesDetailsLoadingShell() {
  const { width } = useWindowDimensions();
  const { isCompact, carouselHeight } = getUnitDetailsLayout(width);
  const { UNIT_DETAILS: labels } = usePropertyLabels();
  const homePath = '/(auth)/(home)';
  const pageTitle = labels.TITLE;

  return (
    <WebAppLayout
      activeTab="home"
      headerTitle={pageTitle}
      breadcrumbs={[
        { label: labels.HOME_BREADCRUMB, path: homePath, replace: true },
        { label: pageTitle },
      ]}
      showBackButton
      hideSidebar
      onBackPress={() => {
        router.replace(homePath as never);
      }}
    >
      <PropertiesDetailsScreenSkeleton
        isMobile={isCompact}
        carouselHeight={carouselHeight}
      />
    </WebAppLayout>
  );
}
